import { useQuery } from "react-query";
import ApiService from "../services/ApiService";
import { Option } from "@cs/components/src/Select";

const apiPath = "/api/select_option/_/organization";

export const useOrganizationQuery = (enabled?: boolean) => {
  return useQuery({
    queryKey: ["select_options", apiPath],
    queryFn: async () => {
      const response = await ApiService.fetch<{ data: Option[] }>(
        "GET",
        apiPath
      );
      return response.data;
    },
    enabled: enabled !== false,
  });
};
